import { DATE_FORMAT } from "../../Utils/date_utils";
import { INITIALIZE_STORE } from "../actions/manager.actions";
import {
	TEAM_SET_LOADING,
	TEAM_SET_TEAM_BASIC_INFO,
	TEAM_SET_PLAYERS,
	TEAM_SET_POSITIONS,
	TEAM_SET_GAMES,
	TEAM_SET_METRICS,
	TEAM_SET_COLOR_REF,
	TEAM_SET_HAS_WELLNESS,
	TEAM_SET_INFORMATION,
	TEAM_SET_FILTERS,
	TEAM_SET_TRAININGS,
	TEAM_SET_PRACTICE_PLAN,
	TEAM_SET_DRILL_COST_PER_MIN,
	TEAM_SET_TESTING_DATA,
	TEAM_SET_TESTING_RARDAR_METRICS,
	TEAM_SET_TESTING_RADAR_DATA,
	TEAM_SET_TESTING_TABLE_DATA,
	TEAM_SET_PLAYER_GROUPS,
	TEAM_SET_TESTING_STAT_DEFAULTS,
	TEAM_SET_FP_DATA,
	TEAM_SET_FORCEPLATE_STAT_DEFAULTS,
	TEAM_SET_PLAYER_PROFILE_STAT_DEFAULTS,
  	TEAM_SET_FPMS_DATA,
	TEAM_SET_FP_METRICS,
	TEAM_SET_WELLNESS_STAT_DEFAULTS,
	TEAM_SET_GPS_STAT_DEFAULTS,
	TEAM_SET_NUTRITION_STAT_DEFAULTS,
	TEAM_SET_DRILLS,
	TEAM_SET_REST_TRAVEL_DATES,
	TEAM_SET_CHARTS,
	TEAM_SET_ALL_PLAYERS,
	TEAM_SET_ALL_POSITIONS,
	TEAM_SET_ALL_TEAM_METRICS,
	TEAM_SET_SPORT,
	TEAM_SET_PRESETS,
	TEAM_SET_OVERVIEW_STATS,
	TEAM_SET_MISC_CONSTANTS,
	TEAM_SET_METRIC_DROPDOWNS,
	TEAM_SET_SCATTERPLOT_FILTERS,
	TEAM_SET_SCATTERPLOT_ERROR,
	TEAM_SET_SCATTERPLOT_DATA,
	TEAM_SET_PROFILE_PRESET_NAME,
	TEAM_SET_DVAI_SUGGESTED_QUESTIONS,
	TEAM_SET_COLOR_STRATEGIES
} from "../actions/team.actions";
import moment from "moment";

const initialState = {
	info: {
		restAndTravel: {},
		coach_list: [],
		display_name: "",
		gender: "",
		gps_unit: null,
		hideDistanceZones: null,
		id: null,
		key_metrics: [],
		metric: null,
		players_view_data: null,
		sessions: [],
		team_colors: {},
		team_logo: null,
		custom_charts: {},
		permissions_manager_list: [],
		difficulty_bar_config: {}
	},
	teamCharts: {
		aerobic: null,
		movementSignature: null,
	},
	drills: [],
	positions: [],
	sport: "",
	allPositions: [],
	players: [],
	allPlayers: [],
	playerGroups: [],
	games: [],
	metrics: [],
	colorRefs: [],
	costPerMin: [],
	hasWellness: false,
	filter: {
		showGameDays: false,
		showPredictions: false,
		showWeekly: false,
		startDate: moment().subtract(2, "weeks").format(DATE_FORMAT),
		endDate: moment().format(DATE_FORMAT),
		position: [],
		player_group: [],
		session: [],
		testingStats: false,
		forceplateStats: false,
		wellnessStats: false,
		gpsData: false,
	},
	trainings: { data: [], metrics: [], colors: [], wellness_metrics: [] },
	practicePlan: [],

	testingStatDefaults: [],
	forceplateStatDefaults: [],
	playerProfileStatDefaults: [[], []],
	wellnessStatDefaults: [],
	gpsStatDefaults: [],
	nutritionStatDefaults: [],
	testingData: {
		key_stats: [],
		std_dev: [],
		data: [],
		options: [],
		optionsV2: [],
	},
	testingRadarData: {
		avg_perc_change: null,
		data: [],
		last_perc_change: null,
	},
	testingTableData: {
		all_dates: [],
		data: [],
		low_good: [],
		player_bests: [],
		std_dev: [],
	},
	dropdowns: {
		testing: [],
  		forceplate: [],
		gps: [],
		wellness: [],
		player: [],
		nutrition: [],
	},
	scatterplot_filters: {
		startDate: moment().subtract(2, "weeks").format(DATE_FORMAT),
		endDate: moment().format(DATE_FORMAT),
		xAxisMetric: null,
		yAxisMetric: null,
		playerSelections: [],
		groupByGameDate: false,
		useAvgValues: false
	},
	scatterplot_data: {
		data: [],
	},
	scatterplot_error: null,
	radarMetrics: [],
	all_metric_types: { gps: [], wellness: [], forceplate: [], testing: [], nutrition: [] },
	fpData: { data: [], key_stats: [], optionsV2: [] },
	fpMetrics: ["jump_height", "mRSI", "load", "explode"],
	overviewStats: [],
	loading: {},
	misc: {},
	presets: [],
	profilePresetName: "Default",
	dvaiSuggestedQuestions: [],
	color_strategies: []
};

export const teamReducer = (state = initialState, action) => {
	switch (action.type) {
    case TEAM_SET_METRIC_DROPDOWNS:
			const { metricType, data } = action.payload;
			const updatedDropdowns = {
				...state.dropdowns,
				[metricType]: data
			};

			const player_dropdown_template = [
				{ key: 'gps', label: 'GPS'},
				{ key: 'wellness', label: 'Wellness'},
				{ key: 'testing', label: 'Testing'},
				{ key: 'forceplate', label: 'Forceplate'},
				{ key: 'nutrition', label: 'Nutrition'}
			]

			updatedDropdowns.player = [];
			player_dropdown_template.forEach((type) => {
				if (updatedDropdowns[type.key].length > 0) {
					updatedDropdowns.player.push({
						key: type.key,
						label: type.label,
						children: updatedDropdowns[type.key]
					})
				}
			})

			return {
				...state,
				dropdowns: updatedDropdowns
			};
		case TEAM_SET_TEAM_BASIC_INFO:
			return { ...state, info: { ...state.info, ...action.data } };
		case TEAM_SET_POSITIONS:
			return { ...state, positions: action.data };
		case TEAM_SET_SPORT:
			return { ...state, sport: action.data };
		case TEAM_SET_PLAYERS:
			return { ...state, players: action.data };
		case TEAM_SET_GAMES:
			return { ...state, games: action.data };
		case TEAM_SET_METRICS:
			return { ...state, metrics: action.data };
		case TEAM_SET_COLOR_REF:
			return { ...state, colorRefs: action.data };
		case TEAM_SET_HAS_WELLNESS:
			return { ...state, hasWellness: action.data };
		case TEAM_SET_INFORMATION:
			return { ...state, ...action.data };
		case TEAM_SET_FILTERS:
			return { ...state, filter: { ...state.filter, ...action.data } };
		case TEAM_SET_TRAININGS:
			return { ...state, trainings: action.data };
		case TEAM_SET_PRACTICE_PLAN:
			return { ...state, practicePlan: action.data };
		case TEAM_SET_DRILL_COST_PER_MIN:
			return { ...state, costPerMin: action.data };
		case TEAM_SET_TESTING_STAT_DEFAULTS:
			return { ...state, testingStatDefaults: action.data };
		case TEAM_SET_TESTING_DATA:
			return { ...state, testingData: action.data };
		case TEAM_SET_TESTING_RARDAR_METRICS:
			return { ...state, radarMetrics: action.data };
		case TEAM_SET_TESTING_RADAR_DATA:
			return { ...state, testingRadarData: action.data };
		case TEAM_SET_TESTING_TABLE_DATA:
			return { ...state, testingTableData: action.data };
		case TEAM_SET_PLAYER_GROUPS:
			return { ...state, playerGroups: action.data };
		case TEAM_SET_FP_DATA:
			return { ...state, fpData: action.data };
		case TEAM_SET_FPMS_DATA:
			return { ...state, fpmsData: action.data };
		case TEAM_SET_MISC_CONSTANTS:
			return { ...state, misc: action.data };
		case TEAM_SET_PRESETS:
			return { ...state, presets: action.data };
		case TEAM_SET_FP_METRICS:
			return { ...state, fpMetrics: action.data };
		case TEAM_SET_FORCEPLATE_STAT_DEFAULTS:
			return { ...state, forceplateStatDefaults: action.data };
		case TEAM_SET_PLAYER_PROFILE_STAT_DEFAULTS:
			return { ...state, playerProfileStatDefaults: action.data };
		case TEAM_SET_WELLNESS_STAT_DEFAULTS:
			return { ...state, wellnessStatDefaults: action.data };
		case TEAM_SET_GPS_STAT_DEFAULTS:
			return { ...state, gpsStatDefaults: action.data };
		case TEAM_SET_NUTRITION_STAT_DEFAULTS:
			return { ...state, nutritionStatDefaults: action.data };
		case TEAM_SET_DRILLS:
			return { ...state, drills: action.data };
		case TEAM_SET_SCATTERPLOT_DATA:
			return { ...state, scatterplot_data: action.data };
		case TEAM_SET_SCATTERPLOT_ERROR:
			return { ...state, scatterplot_error: action.data };
		case TEAM_SET_SCATTERPLOT_FILTERS:
			return { ...state, scatterplot_filters: { ...state.scatterplot_filters, ...action.data } };
		case TEAM_SET_OVERVIEW_STATS:
			return {
				...state,
				overviewStats: action.data.concat(
					new Array(8).fill("").slice(0, 8)
				),
			};
		case TEAM_SET_REST_TRAVEL_DATES:
			return {
				...state,
				info: {
				...state.info,
				restAndTravel: action.data.reduce((acc, curr) => {
					acc[curr.date] =
					(curr.rest ? 2 : 0) + (curr.travel ? 1 : 0) + (curr.lift ? 4 : 0);
					return acc;
				}, {}),
				},
			};
		case TEAM_SET_ALL_TEAM_METRICS:
			return {
				...state,
				all_metric_types: {
					gps: action.data.filter((x) => x.metric_type === "gps"),
					testing: action.data.filter(
						(x) => x.metric_type === "testing"
					),
					forceplate: action.data.filter(
						(x) => x.metric_type === "forceplate"
					),
					wellness: action.data.filter(
						(x) => x.metric_type === "wellness"
					),
					nutrition: action.data.filter(
						(x) => x.metric_type === "nutrition"
					),
				},
			};
		case TEAM_SET_ALL_PLAYERS:
			return { ...state, allPlayers: action.data };
		case TEAM_SET_ALL_POSITIONS:
			return { ...state, allPositions: action.data };
		case TEAM_SET_CHARTS:
			return { ...state, teamCharts: {
				...state.teamCharts,
				[action.chartType]: action.data
			} };
		case TEAM_SET_LOADING:
			return { ...state, loading: { ...state.loading, ...action.data } };
		case INITIALIZE_STORE:
			return initialState;
		case TEAM_SET_PROFILE_PRESET_NAME:
			return { ...state, profilePresetName: action.data }
		case TEAM_SET_DVAI_SUGGESTED_QUESTIONS:
			return { ...state, dvaiSuggestedQuestions: action.data }
		case TEAM_SET_COLOR_STRATEGIES:
			return { ...state, color_strategies: action.data ?? [] }
		default:
			return state;
	}
};
